import { Injectable } from '@angular/core';
import { PrizesService } from './prizes.service';
import { MongoService } from './mongo.service';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root'
})
export class RankingService {

  constructor(
    private prizesService: PrizesService,
    private mongoService: MongoService,
    private stateService: StateService
  ) { }

  public async prepareRankng(){
    console.log("rozpoczynam obliczanie rankingu");
    let usersData = await this.mongoService.getAllUsersData();
    const originalCount = usersData?.length ?? 0;
    usersData = await this.countAllUsersDataPoints(usersData);
    usersData = await this.prepareRankingArray(usersData);
    usersData = await this.assignRewards(usersData);

    // Zawór bezpieczeństwa: nie kasuj kolekcji, jeśli przetwarzanie zwróciło
    // niespójną liczbę rekordów (chroni przed utratą wszystkich usersData).
    if (originalCount > 0 && (!usersData || usersData.length !== originalCount)) {
      console.error(`Przerwano przebudowę rankingu: oczekiwano ${originalCount} rekordów, otrzymano ${usersData?.length ?? 0}. Kolekcja usersData NIE została zmieniona.`);
      return;
    }

    // atomowa podmiana całej kolekcji (#5) — przy błędzie usersData pozostaje nietknięta
    await this.mongoService.replaceUsersData(usersData);
    console.log("kończę obliczanie rankingu");
  }


  public async countAllUsersDataPoints(usersData: Array<any>) {
    try {
      const qualifies = (u: any) => u.registered && u.isAirConditionStatutAccepted && u.isPumpStatutAccepted;
      for (const userData of usersData) {
        // Rebuild danej kampanii modyfikuje WYŁĄCZNIE punkty tej kampanii —
        // nie zeruje punktów drugiej (koniec skażenia między kampaniami).
        if (this.stateService.getState() == "state-pumps") {
          userData.pumpPoints = qualifies(userData) ? await this.countRegisteredProductsScore(userData) : 0;
        } else if (this.stateService.getState() == "state-airconditioners") {
          userData.airConditionPoints = qualifies(userData) ? await this.countRegisteredProductsScore(userData) : 0;
        }
      }
      return usersData;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  private async countRegisteredProductsScore(userData: any) {
    try {
      if(this.stateService.getState() == 'state-pumps'){
        return (userData.pumpRegisteredProducts ?? []).reduce((sum: any, product: any) => sum + product.score, 0);
      } else if(this.stateService.getState() == 'state-airconditioners'){
        return (userData.airConditionRegisteredProducts ?? []).reduce((sum: any, product: any) => sum + product.score, 0);
      }
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  //funkcja tworzy ranking
  //sortuje po liczbie zgromadzonych przez użtkowników punktów
  //jeżeli liczba punktów jest taka sama dla więcej niż jednego użtykownika bierze pod uwagę najwczesniejszą datę rejestracji któregokolwiek z urządzeń
  public async prepareRankingArray(allUsersData: any): Promise<Array<any>> {
    try {
      if(this.stateService.getState() == 'state-pumps'){
        const sortedUsers = allUsersData.sort((a: any, b: any) => {
          if (a.pumpPoints !== b.pumpPoints) {
            return b.pumpPoints - a.pumpPoints; // Sortuj według points malejąco
          }
          const earliestDateA = getEarliestDate(a.pumpRegisteredProducts);
          const earliestDateB = getEarliestDate(b.pumpRegisteredProducts);
          return earliestDateA - earliestDateB;
        });
  
        // Dodawanie właściwości 'position'
        sortedUsers.forEach((user: any, index: number) => {
          user.pumpPosition = index + 1; // Pozycja w rankingu
        });
        return sortedUsers;
      } else if(this.stateService.getState() == 'state-airconditioners'){ 
        const sortedUsers = allUsersData.sort((a: any, b: any) => {
          if (a.airConditionPoints !== b.airConditionPoints) {
            return b.airConditionPoints - a.airConditionPoints; // Sortuj według points malejąco
          }
          const earliestDateA = getEarliestDate(a.airConditionRegisteredProducts);
          const earliestDateB = getEarliestDate(b.airConditionRegisteredProducts);
          return earliestDateA - earliestDateB;
        });
  
        // Dodawanie właściwości 'position'
        sortedUsers.forEach((user: any, index: number) => {
          user.airConditionPosition = index + 1; // Pozycja w rankingu
        });
        return sortedUsers;
      } else {
        return [];
      }

      function getEarliestDate(products: any) {
        return (products ?? []).reduce((earliest: any, product: any) => {
          const date = parseDate(product.date);
          return date < earliest ? date : earliest;
        }, new Date(9999, 11, 31)); // Data bardzo daleko w przyszłości
      }
      function parseDate(dateStr: any) {
        // Format daty: "24-02-28 11:11"
        const [datePart, timePart] = dateStr.split(' ');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);

        // Tworzenie daty
        return new Date(year + 2000, month - 1, day, hour, minute);
      }
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  //iteruje po liście posortowanych wg liczby punktów użytkowników, przypisuje wartość pieniężną nagrody do użytkownika
  public async assignRewards(rankingSortedUsersData: any): Promise<Array<any>> {
    try {
      //pobierz tabelę nagrod prizes
      let rewardsList:any = []; //await this.prizesService.getAllPrizes();
      if(this.stateService.getState() == 'state-pumps'){
        rewardsList = await this.mongoService.getAllPumpsPrizesData();

        let iterator = 0;
        //wyzeruj wszystkim prizeAmount
        rankingSortedUsersData = rankingSortedUsersData.map((elem:any) => {
          return { ...elem, pumpPrizeAmount: 0 };
        });
        //przypisz prizeAmount
        rewardsList.forEach((reward: any) => {
          if (rankingSortedUsersData[iterator] && (rankingSortedUsersData[iterator].pumpPoints > 0) && rankingSortedUsersData[iterator].registered) {
            rankingSortedUsersData[iterator].pumpPrizeAmount = reward.prizeAmount;
          }
          iterator++
        });
        iterator = 0;
        return rankingSortedUsersData;
      } else if(this.stateService.getState() == 'state-airconditioners'){ 
        rewardsList = await this.mongoService.getAllAirconditionersPrizesData();

        let iterator = 0;
        //wyzeruj wszystkim prizeAmount
        rankingSortedUsersData = rankingSortedUsersData.map((elem:any) => {
          return { ...elem, airConditionPrizeAmount: 0 };
        });
        //przypisz prizeAmount
        rewardsList.forEach((reward: any) => {
          if (rankingSortedUsersData[iterator] && (rankingSortedUsersData[iterator].airConditionPoints > 0) && rankingSortedUsersData[iterator].registered) {
            rankingSortedUsersData[iterator].airConditionPrizeAmount = reward.prizeAmount;
          }
          iterator++
        });
        iterator = 0;
        return rankingSortedUsersData;
      } else return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
